import { Button, Icon } from "@blueprintjs/core"
import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"
import { ITableTrProps } from "./TableTr"
import { HISTORY_TYPE, IHistoryStep, ILandingSection, LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces"
import updateSection from "../../landing-edit/utils/updateSection"

/* Protopia Ecosystem component */
export interface ITableTrNullProps extends ITableTrProps {
   
}
const TableTrNull = (props: ITableTrProps): JSX.Element => {
    const isEdit : boolean = useLandingConsoleStore((state: ILandingConsoleStore) => state.isEdit )
    const onUnhide = () => {
        const prevData: ILandingSection = JSON.parse( JSON.stringify(props.section) )
        const data: ILandingSection = {
            ...props.section!,
            data: props.section!.data.map(meat => {
                if(meat.type === LANDING_TYPE_CONTENT.TABLE && meat.id === props.primitive.id ) {
                    return {
                        ...props.primitive,
                        data: props.primitive.data.map((row, i) => {
                            if( i === props.i) {
                                return {
                                    ...row,
                                    isHidden: !row.isHidden
                                }
                            }
                            return row
                        })
                    }
                }
                return meat
            })
        }
        const historyStep: IHistoryStep = {
            data,
            prevData,
            type: HISTORY_TYPE.SECTION,
            title: "Change table row visible " 
        }
        updateSection( data, historyStep )
    }
    return isEdit
        ?
        <Button onClick={onUnhide}>
            <Icon icon="eye-off" />
        </Button>
        :
        <></>
}
export default TableTrNull